import { Navigate } from "react-router";
import { SelfContextProvider } from "../contexts/SelfContext";
import { useContext, useEffect, useRef } from "react";
import { AuthContext } from "../contexts/AuthContext";

export const AuthGuard = ({ children }: { children: React.ReactNode }) => {
  const contextAuth = useContext(AuthContext);

  const storedToken = localStorage.getItem("NAGA_ADMIN:token");
  const shouldCheckToken = useRef(true);

  useEffect(() => {
    if (storedToken && shouldCheckToken.current) {
      contextAuth.onUpdateToken(storedToken);
      shouldCheckToken.current = false;
    }
  }, [contextAuth, shouldCheckToken, storedToken]);

  if (storedToken != null && storedToken) {
    return (
      <SelfContextProvider>
        <>{children}</>
      </SelfContextProvider>
    );
  } else {
    return <Navigate to="/" replace />;
  }
};
